import email from "../assets/email.png";
import css from "../assets/css.png";
import git from "../assets/git.png";
import html from "../assets/html.png";
import javascript from "../assets/javascript.png";
import react from "../assets/react.png";
import redux from "../assets/redux.png";
import sass from "../assets/sass.png";
import typescript from "../assets/typescript.png";
import java from "../assets/java.jpeg";
import firebase from "../assets/firebase.jpg";
import tailwind from "../assets/tailwind.png";
import about01 from "../assets/about01.jpg";
import about02 from "../assets/about02.png";
import writer from "../assets/writer.png";
import circle from "../assets/circle.svg";
import reactNative from "../assets/react-native.png";
import me from "../assets/me.png";
import nextjs from "../assets/nextjs.png";
import tesla from "../assets/tesla.png";
import uber from "../assets/Uber.png";
import gossip from "../assets/Gossip.png";
import github from "../assets/github.png";
import twitter from "../assets/twitter.png";
import linkedln from "../assets/linkedln.png";
import medium from "../assets/medium.png";
import topmate from "../assets/topmate.jpg";
import bracket from "../assets/Bracket.png";
import viber from "../assets/viber.png";
import vibers from "../assets/viber1.png";
import notion from "../assets/notion.png";
import todolist from "../assets/todolist.png";
import calculator from "../assets/calculator.png";
import recipe from "../assets/recipe.png";
import resume from "../assets/resume.pdf";
export default {
   bracket,
   viber,
   vibers,  
   todolist,
   calculator,
   recipe,
   topmate,
   notion,
   github,
   twitter,
   linkedln,
   gossip,
   uber,
   tesla,
   nextjs,
   email,
   css,
   git,
   html,
   javascript,
   react,
   redux,
   writer,
   sass,
   typescript,
   about01,
   about02,
   circle,

   me,
   java,
   firebase,
   tailwind,
   reactNative,
   medium,
   resume,
};
